import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { CorretoraService } from '../services/corretora.service';
import { AuthService } from '../services/auth.service';
import { ExcelService } from '../services/excel.service';
import Swal from 'sweetalert2';

import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';


@Component({
  selector: 'app-corretora',
  templateUrl: './corretora.component.html',
  styleUrls: ['./corretora.component.css'],
	animations: [loadingFade, modal, alert]
})
export class CorretoraComponent implements OnInit {
	public loading = false;
	public corretoras = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

		//acesso
		public menu_id = 127; //Fornecedor - ADM
		public usuario_perfil;
		public visualizar = true;
		public editar = false;	

	constructor(
		private corretoraSvc: CorretoraService,
		private authSvc: AuthService,
		private excelSvc: ExcelService,
		private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {


		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		this.pegaCorretoras();
	}

	pegaCorretoras() {
		this.loading = true;
		this.corretoraSvc.getCorretoras().then((data: any) => {
			this.corretoras = data;
			this.count = this.corretoras.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaCorretora(id) {
		Swal.fire({
			type: 'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'

		}).then((result) => {
			if (result.value == true) {
				this.corretoraSvc.apagaCorretora(id).then((data) => {
					this.pegaCorretoras();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}
}
